import { render, staticRenderFns } from "./DeviceModel.vue?vue&type=template&id=1b492fe8&scoped=true&"
import script from "./DeviceModel.vue?vue&type=script&lang=js&"
export * from "./DeviceModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b492fe8",
  null
  
)

export default component.exports